import { SubmitHandler, useForm } from "react-hook-form";
import { Box, Button } from "@mui/material";
import React, { useState } from "react";

import { formConfig } from "./formConfig";
import Field from "@/components/RHFcomponents/Field";
import { applyFormStyles } from "./styles";
import Notification from "@/components/Notification/Notification.tsx";
import { useApplyPromoCodeMutation } from "@/redux-store/api/marketingApi";

interface IProps {
  setOrderSummary: React.Dispatch<React.SetStateAction<IOrderSummary>>;
  onPromoSubmit: () => void;
}

const ApplyPromo: React.FC<IProps> = ({  setOrderSummary, onPromoSubmit }) => {
  // Form control for Promo using React Hook Form
  const methods = useForm<IPromo>(formConfig);
  const { handleSubmit, control, reset } = methods;
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);

  const [notification, setNotification] = useState({
    open: false,
    title: "",
    description: "",
  });

  const [applyPromoCode] = useApplyPromoCodeMutation();

  const onSubmit: SubmitHandler<IPromo> = async (data) => {
    if (!data.promo) return;
    setNotificationIsOpen(true);

    try {
      const promo = await applyPromoCode(data.promo).unwrap();
      setOrderSummary((prevState) => ({
        ...prevState,
        promoCodeId: promo?.id || null,
        discount: promo.percentageOff || 0,
      }));

      onPromoSubmit();
    } catch (e) {
      const error = e as { data: string }

      setNotification({
        open: true,
        title: "Error",
        description: error.data,
      });
    }
    setTimeout(() => {
      setNotificationIsOpen(false);
    }, 2500);
    reset();
  };

  return (
    <>
      <Box
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        display="flex"
        gap={{ xs: 2 }}
        py={3}
        sx={applyFormStyles}
      >
        <Field name="promo" control={control} placeholder="Promo code" />
        <Button
          variant="contained"
          type="submit"
          sx={{ minWidth: { xs: 126, sm: 156 } }}
        >
          Apply
        </Button>
      </Box>
      {notification.title && notification.description && (
      <Notification
          open={notificationIsOpen}
          onClose={() => setNotificationIsOpen(false)}
          title={notification.title}
          description={notification.description}
          severity="error"
      />
      )}
    </>
  );
};

export default ApplyPromo;
